var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightFullArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.519 9c.172 0 .309-.096.489-.215L8.52 5.258C8.884 5.021 9 4.8 9 4.5s-.116-.515-.48-.753L3.008.215C2.824.096 2.686 0 2.515 0 2.197 0 2 .317 2 .809l.004 7.381c0 .492.197.809.515.809z"
  })));
}

export default SvgRightFullArrow;